import {useEffect, useRef} from "react";
import {useLocation} from "react-router-dom";

import {BOTTOM_NAV_AUTO_HIDE} from "../constants/bottom_nav_auto_hide";
import {resolveMobileBottomNavHidden} from "../utils/resolve_mobile_bottom_nav_hidden";

const getBottomNavHideLockPx = (root: HTMLElement) => {
    const rootStyle = getComputedStyle(root);
    const raw = rootStyle.getPropertyValue("--layout-bottomNavOffset").trim();
    const parsed = Number.parseFloat(raw);

    if (!Number.isFinite(parsed) || parsed <= 0) return BOTTOM_NAV_AUTO_HIDE.BOTTOM_LOCK_PX + BOTTOM_NAV_AUTO_HIDE.TOP_PX;

    const offsetPx = raw.endsWith("rem") ? parsed * (Number.parseFloat(rootStyle.fontSize) || 10) : parsed;

    return offsetPx + BOTTOM_NAV_AUTO_HIDE.TOP_PX;
};

const setBottomNavHiddenAttribute = (isHidden: boolean) => {
    document.documentElement.setAttribute(BOTTOM_NAV_AUTO_HIDE.ATTR, isHidden ? BOTTOM_NAV_AUTO_HIDE.HIDDEN : BOTTOM_NAV_AUTO_HIDE.VISIBLE);
};

export const useMobileBottomNavAutoHide = (isEnabled: boolean) => {
    const {pathname} = useLocation();
    const accumulatedDeltaRef = useRef(0);
    const isHiddenRef = useRef(false);
    const previousScrollYRef = useRef(0);

    useEffect(() => {
        if (!isEnabled) {
            accumulatedDeltaRef.current = 0;
            isHiddenRef.current = false;
            document.documentElement.removeAttribute(BOTTOM_NAV_AUTO_HIDE.ATTR);
            return;
        }

        accumulatedDeltaRef.current = 0;
        isHiddenRef.current = false;
        previousScrollYRef.current = Math.max(0, window.scrollY);
        setBottomNavHiddenAttribute(false);

        const updateVisibility = () => {
            const root = document.documentElement;
            const scrollY = Math.max(0, window.scrollY);
            const maxScrollY = Math.max(0, root.scrollHeight - window.innerHeight);
            const hideLockPx = getBottomNavHideLockPx(root);
            const nextState = resolveMobileBottomNavHidden({
                accumulatedDelta: accumulatedDeltaRef.current,
                canScroll: root.scrollHeight > window.innerHeight + 1,
                distanceFromBottom: Math.max(0, maxScrollY - scrollY),
                hideLockPx,
                isHidden: isHiddenRef.current,
                previousScrollY: previousScrollYRef.current,
                scrollY
            });

            accumulatedDeltaRef.current = nextState.accumulatedDelta;
            previousScrollYRef.current = scrollY;

            if (nextState.isHidden === isHiddenRef.current) return;

            isHiddenRef.current = nextState.isHidden;
            setBottomNavHiddenAttribute(nextState.isHidden);
        };

        window.addEventListener("scroll", updateVisibility, {passive: true});
        window.addEventListener("resize", updateVisibility);

        return () => {
            window.removeEventListener("scroll", updateVisibility);
            window.removeEventListener("resize", updateVisibility);
            document.documentElement.removeAttribute(BOTTOM_NAV_AUTO_HIDE.ATTR);
        };
    }, [isEnabled, pathname]);
};
import {useEffect, useRef} from "react";
import {useLocation} from "react-router-dom";

import {BOTTOM_NAV_AUTO_HIDE} from "../constants/bottom_nav_auto_hide";
import {resolveMobileBottomNavHidden} from "../utils/resolve_mobile_bottom_nav_hidden";

const getBottomNavHideLockPx = (root: HTMLElement) => {
    const rootStyle = getComputedStyle(root);
    const raw = rootStyle.getPropertyValue("--layout-bottomNavOffset").trim();
    const parsed = Number.parseFloat(raw);

    if (!Number.isFinite(parsed) || parsed <= 0) return BOTTOM_NAV_AUTO_HIDE.BOTTOM_LOCK_PX + BOTTOM_NAV_AUTO_HIDE.TOP_PX;

    const offsetPx = raw.endsWith("rem") ? parsed * (Number.parseFloat(rootStyle.fontSize) || 10) : parsed;

    return offsetPx + BOTTOM_NAV_AUTO_HIDE.TOP_PX;
};

const setBottomNavHiddenAttribute = (isHidden: boolean) => {
    document.documentElement.setAttribute(BOTTOM_NAV_AUTO_HIDE.ATTR, isHidden ? BOTTOM_NAV_AUTO_HIDE.HIDDEN : BOTTOM_NAV_AUTO_HIDE.VISIBLE);
};

export const useMobileBottomNavAutoHide = (isEnabled: boolean) => {
    const {pathname} = useLocation();
    const accumulatedDeltaRef = useRef(0);
    const isHiddenRef = useRef(false);
    const previousScrollYRef = useRef(0);

    useEffect(() => {
        if (!isEnabled) {
            accumulatedDeltaRef.current = 0;
            isHiddenRef.current = false;
            document.documentElement.removeAttribute(BOTTOM_NAV_AUTO_HIDE.ATTR);
            return;
        }

        accumulatedDeltaRef.current = 0;
        isHiddenRef.current = false;
        previousScrollYRef.current = Math.max(0, window.scrollY);
        setBottomNavHiddenAttribute(false);

        const updateVisibility = () => {
            const root = document.documentElement;
            const scrollY = Math.max(0, window.scrollY);
            const maxScrollY = Math.max(0, root.scrollHeight - window.innerHeight);
            const hideLockPx = getBottomNavHideLockPx(root);
            const nextState = resolveMobileBottomNavHidden({
                accumulatedDelta: accumulatedDeltaRef.current,
                canScroll: root.scrollHeight > window.innerHeight + 1,
                distanceFromBottom: Math.max(0, maxScrollY - scrollY),
                hideLockPx,
                isHidden: isHiddenRef.current,
                previousScrollY: previousScrollYRef.current,
                scrollY
            });

            accumulatedDeltaRef.current = nextState.accumulatedDelta;
            previousScrollYRef.current = scrollY;

            if (nextState.isHidden === isHiddenRef.current) return;

            isHiddenRef.current = nextState.isHidden;
            setBottomNavHiddenAttribute(nextState.isHidden);
        };

        window.addEventListener("scroll", updateVisibility, {passive: true});
        window.addEventListener("resize", updateVisibility);

        return () => {
            window.removeEventListener("scroll", updateVisibility);
            window.removeEventListener("resize", updateVisibility);
            document.documentElement.removeAttribute(BOTTOM_NAV_AUTO_HIDE.ATTR);
        };
    }, [isEnabled, pathname]);
};
